import React from "react";
import TreeNode from "./TreeNode.component";
import useStateOfRegulationsTree from "../../hooks/useStateOfRegulationsTree";

const Tree = ({
  treeData,
  getNode,
  deleteNode,
  changeNode,
  createNode,
  createOtherNode,
  deactivateNode,
  onFilteredNode,
  isRight,
  isMoving,
  selectForMoving,
  isSearching
}) => {

   const { arrayOfAreaIds } = useStateOfRegulationsTree();
  
  const expandFunction = (id) => {
    var val = arrayOfAreaIds?.some(el => el === id);
     return val || [];
  }

  return (
    <ul>
      {treeData.map((node) => (
        <TreeNode
          node={node}
          key={node.id}
          getNode={getNode}
          deleteNode={deleteNode}
          changeNode={changeNode}
          createNode={createNode}
          createOtherNode={createOtherNode}
          deactivateNode={deactivateNode}
          onFilteredNode={onFilteredNode}
          isRight={isRight}
          expanded={!isMoving && expandFunction(node.id)}
          isMoving={isMoving}
          selectForMoving={selectForMoving}
          isSearching={isSearching}
        />
      ))}
    </ul>
  );
};

export default Tree;
